import { createTheme, ThemeProvider } from '@mui/material';
import React from 'react';

const theme = createTheme({
    components: {
        MuiInputBase: {
            styleOverrides: {
                root: {
                    backgrounColor: '#FFFFFF'
                }
            }
        }
    },
    typography: {
        allVariants: {
            color: "#111111"
        },
        caption: {
            color: '#11111'
        },
        h1: {
            fontSize: '2.5rem'
        },
        h2: {
            fontSize: '2.2rem'
        },
        h3: {
            fontSize: '1.9rem'
        },
        h4: {
            fontSize: '1.5rem'
        },
        h5: {
            fontSize: '1.3rem'
        }
    },
    palette: {
        text: {
            primary: '#4d4d4d',
            secondary: '#6f6663',
            disabled: '#897E79',
        },
        primary: {
            main: '#EB6723'
        },
    },

});

export const AppTheme = (props: { children: React.ReactNode; }) => {
    return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
};
